import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { hasSessionEvents } from "@/shared/domain/orgs";
import { useOrgEventModel } from "@/shared/domain/orgs/hooks";

import { STALE_QUERY_TIMEOUT_MSEC } from "./constants";

export function useEventNames(orgId: string): UseQueryResult<string[], Error> {
  const { events } = useDomainServices();
  const includeSessionEvents = hasSessionEvents(useOrgEventModel(orgId));

  return useQuery({
    queryKey: ["orgEventNames", orgId, includeSessionEvents],
    queryFn: ({ signal }) => {
      return events.getNamesForOrg({
        abortSignal: signal,
        resourceOwnerId: orgId,
        includeSessionEvents,
      });
    },
    staleTime: STALE_QUERY_TIMEOUT_MSEC,
  });
}
